import {
    GET_CURRENT_SCHEDULE,
    GET_COMPLETED_SCHEDULE,
    GET_AVAILABILITY,
    ADD_AVAILABILITY,
    REMOVE_AVAILABILITY,
    UPDATE_NOTE
} from '../actions/types';

const initialState = {
    schedule: {},
    completedSchedule: {},
    availability: {},
    newAvailability: {}
};

export default function(state = initialState, action) {
    switch (action.type) {
        case GET_CURRENT_SCHEDULE:
            return {
                ...state,
                schedule: action.payload
            };
        case GET_COMPLETED_SCHEDULE:
            return {
                ...state,
                completedSchedule: action.payload
            };
        case GET_AVAILABILITY:
            state.availability = action.payload;
            if (state.availability.data.availability_slots !== undefined) {
                var byDate = state.availability.data.availability_slots.slice(0);
                byDate.sort(function(a,b) {
                    return Date.parse(a.appointment_date) - Date.parse(b.appointment_date);
                });
                state.availability.data.availability_slots = byDate.reverse();
            }
            return {
                ...state,
            }
        case ADD_AVAILABILITY:
            if (state.availability.data.availability_slots !== undefined) {

                action.payload.data.slot.forEach(function(info) {
                    const slot = {
                        id: info.id,
                        installer_id: info.installer_id,
                        campaign_id: null,
                        wrap_appointment_id: null,
                        wrap_appointment_type_id: info.wrap_appointment_type_id,
                        appointment_date: info.appointment_date,
                        date_created: info.date_created
                    }
                    state.availability.data.availability_slots.push(slot);
                })

                byDate = state.availability.data.availability_slots.slice(0);
                byDate.sort(function(a,b) {
                    return Date.parse(a.appointment_date) - Date.parse(b.appointment_date);
                });
                state.availability.data.availability_slots = byDate.reverse();
            }
            return {
                ...state
            }
        case REMOVE_AVAILABILITY:
            if (state.availability.data.availability_slots !== undefined) {
                state.availability.data.availability_slots.splice(action.payload.row, 1);

                byDate = state.availability.data.availability_slots.slice(0);
                byDate.sort(function(a,b) {
                    return Date.parse(a.appointment_date) - Date.parse(b.appointment_date);
                });
                state.availability.data.availability_slots = byDate.reverse();
            }
            return {
                ...state
            }
        case UPDATE_NOTE:
            let id = action.payload.data.id;
            let notes = action.payload.data.notes;

            state.schedule.data.bookings.forEach(function(booking) {
                if (booking.id === id) {
                    booking.notes = notes;
                }
            })

            state.completedSchedule.data.bookings.forEach(function(booking) {
                if (booking.id === id) {
                    booking.notes = notes;
                }
            })

            return {
                ...state
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/scheduleReducer.jsx